class System {

  constructor(apiClient) {

    this.apiClient = apiClient;

  }

  async getStartupFontFamilies() {

    const path = '/system/font-families';

    return this.apiClient.get(path);

  }

  async getStartupLayouts() {

    const path = '/system/layouts';

    return this.apiClient.get(path);

  }

  async getBrowserClientIPAddress() {

    const path = '/system/browser-client-ip-address';

    return this.apiClient.get(path);

  }

  async getURIDetails(payload) {

    const path = '/system/uri-details';

    return this.apiClient.post(path, {}, {}, payload);

  }

  async getHelptapPermissions(payload) {

    const path = '/system/permissions';

    return this.apiClient.get(path);

  }

  async createLiveStreamMeeting() {

    const path = '/live-stream-poc/meetings';

    return this.apiClient.post(path, {}, {}, {});

  }

  async getLiveStreamMeetingById(meetingId) {

    const path = '/live-stream-poc/meetings/:meetingId';

    return this.apiClient.get(path, { meetingId }, {}, {});

  }

  async joinLiveStreamMeeting(meetingId) {

    const path = '/live-stream-poc/meetings/:meetingId/attendees';

    return this.apiClient.post(path, { meetingId }, {}, {});

  }

  async getCountryCodes() {

    const path = '/system/country-codes';

    return this.apiClient.get(path, {}, {});

  }

  async searchCities(term, limit) {

    const path = '/system/cities';

    return this.apiClient.get(path, {}, { term, limit });

  }

  async getTaxCodes() {

    const path = '/system/tax-codes';

    return this.apiClient.get(path, {}, {});

  }

  async getPrebuiltContactLists() {

    const path = '/system/prebuilt-contact-lists';

    return this.apiClient.get(path, {}, {});

  }

}

export default System;